module.exports = __webpack_public_path__ + "img/hyl_p4.1a70acef.png";